var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntryChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.084,
    cy: 24.7156,
    r: 23,
    fill: "url(#paint0_linear_4200_29109)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5526 29.5456L30.9426 32.7056C31.0426 33.5356 30.1526 34.1155 29.4426 33.6855L25.2526 31.1956C24.7926 31.1956 24.3426 31.1656 23.9026 31.1056C24.6426 30.2356 25.0826 29.1356 25.0826 27.9456C25.0826 25.1056 22.6226 22.8056 19.5826 22.8056C18.4226 22.8056 17.3526 23.1356 16.4626 23.7156C16.4326 23.4656 16.4226 23.2156 16.4226 22.9556C16.4226 18.4056 20.3726 14.7156 25.2526 14.7156C30.1326 14.7156 34.0826 18.4056 34.0826 22.9556C34.0826 25.6556 32.6926 28.0456 30.5526 29.5456Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 27.9456C25.084 29.1356 24.644 30.2357 23.904 31.1057C22.914 32.3057 21.344 33.0756 19.584 33.0756L16.974 34.6256C16.534 34.8956 15.974 34.5256 16.034 34.0156L16.284 32.0457C14.944 31.1157 14.084 29.6256 14.084 27.9456C14.084 26.1856 15.024 24.6356 16.464 23.7156C17.354 23.1356 18.424 22.8057 19.584 22.8057C22.624 22.8057 25.084 25.1056 25.084 27.9456Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4200_29109",
    x1: 2.45222,
    y1: 24.7155,
    x2: 32.4203,
    y2: 58.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C4F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryChat);
export default __webpack_public_path__ + "static/media/entryChat.edeecaae.svg";
export { ForwardRef as ReactComponent };